import React, { Component, lazy } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import { connect } from 'react-redux'

import MakeVideo from "../Routers/MakeVideo"
import Navigator from "../_CustomPages/Wadiz/Navigator"

const WADIZ_Home = lazy(() => import('../_CustomPages/Wadiz/home'))
const WADIZ_DesignSelect = lazy(() => import('../_CustomPages/Wadiz/designSelect'))
const WADIZ_Gallery = lazy(() => import('../_CustomPages/Wadiz/gallery'))
const WADIZ_UseGuide = lazy(() => import("../_CustomPages/Wadiz/useGuide"))
const WADIZ_UserPage = lazy(() => import("../_CustomPages/Wadiz/UserPage"))
const Footer = lazy(() => import("../Footer"))

const SignUp = lazy(() => import("../SignUp/SignUp"))
const Login = lazy(() => import("../Routers/Login"))
const LoginAfterStep = lazy(() => import("../LoginAfterStep/LoginAfterStep1/LoginAfterStep"))
const LoginAfterStep2 = lazy(() => import("../LoginAfterStep/LoginAfterStep2/LoginAfterStep2"))
const LoginAfterStep3 = lazy(() => import("../LoginAfterStep/LoginAfterStep3/LoginAfterStep3"))

const Tos = lazy(() => import('../Footer/TOS'))
const Privacy = lazy(() => import('../Footer/Privacy'))
const RequiredBox = lazy(() => import('../SignUp/requiredBox/requiredBox'))
const SocialWithdraw = lazy(() => import("../SocialWithdraw/SocialWithdraw"))
const Duplicated = lazy(() => import("../Routers/Duplicated"))

class Wadiz extends Component {

    listenLocationChange = (props) => { this.props.listenLocationChange(props) }

    render() {
        const { isMobile, changeLanguage } = this.props

        return (
            <>
            <Navigator changeLanguage={changeLanguage} />
    
            <Switch>
              <Route
                exact
                path="/"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_Home
                    {...props}
                    isMobile={isMobile}
                  />
                }}
              />
    
              <Route
                path="/home"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_Home
                    {...props}
                    isMobile={isMobile}
                  />
                }}
              />
    
              <Route
                path="/designselect"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_DesignSelect {...props} isMobile={isMobile} />
                }}
              />
    
              <Route
                path="/useguide"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_UseGuide {...props} />
                }}
              />
    
              <Route
                path="/wadizgallery"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_Gallery {...props} />
                }}
              />
    
              <Route
                path="/user/:id"
                component={props => {
                  this.listenLocationChange(props)
                  return <WADIZ_UserPage {...props} />
                }}
              />
    
              {/* <Route
                path="/login"
                component={props => {
                  this.listenLocationChange(props)
                  return <Login {...props} />
                }}
              />
    
              <Route
                path="/Signup"
                component={props => {
                  this.listenLocationChange(props)
                  return <SignUp {...props} />
                }}
              /> */}
    
              <Route
                path="/makevideo"
                component={props => {
                  this.listenLocationChange(props)
                  return <MakeVideo {...props} />
                }}
              />
    
              <Route
                path="/Tos"
                component={props => {
                  this.listenLocationChange(props)
                  return <Tos {...props} />
                }}
              />
    
              <Route
                path="/Privacy"
                component={props => {
                  this.listenLocationChange(props)
                  return <Privacy {...props} />
                }}
              />
    
              <Route
                path="/requiredbox"
                component={props => {
                  this.listenLocationChange(props)
                  return <RequiredBox {...props} />
                }}
              />
    
              <Route path="/LoginAfterStep" component={LoginAfterStep} />
              <Route path="/LoginAfterStep2" component={LoginAfterStep2} />
              <Route path="/LoginAfterStep3" component={LoginAfterStep3} />
    
              <Route path="/socialwithdraw" component={props => <SocialWithdraw {...props} />} />
              <Route path="/socialnotfound" component={props => <SocialWithdraw {...props} />} />
              <Route path="/duplicated" component={props => <Duplicated {...props} />} />
    
              <Route path="/make" component={() => <Redirect to={'/designSelect'} />} />
              <Route path="/myVideo" component={() => <Redirect to={'/user/_/my-video'} />} />
              <Route path="/shop" component={() => <Redirect to={'/payment'} />} />
    
              <Route component={() => <Redirect to={'/'} />} />
    
            </Switch>
            <Footer {...this.props} />
          </>
        )
    }
}

export default connect(
    null,
    null
  )(Wadiz);